import React from "react";
import { CalendarDays } from "lucide-react";
import NarrativeAssessmentCardBase from "./NarrativeAssessmentCardBase";

const ContentCalendarNarrativeAssessmentViewer = ({ markdown = "" }) => (
  <NarrativeAssessmentCardBase
    markdown={markdown}
    Icon={CalendarDays}
    titleOverride="Monthly Events Calendar"
    subtitle="Seasonal planning and event sequencing interpretation"
    badge="CALENDAR"
  />
);

export default ContentCalendarNarrativeAssessmentViewer;
